import { render, staticRenderFns } from "./tippage.vue?vue&type=template&id=9ee56470&"
import script from "./tippage.vue?vue&type=script&lang=js&"
export * from "./tippage.vue?vue&type=script&lang=js&"
import style0 from "./tippage.vue?vue&type=style&index=0&id=9ee56470&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports